'use client'

import { createContext } from 'react'

import { EscrowFeesModel } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

export type EscrowFeesContextType = {
  escrowFees?: EscrowFeesModel | null
}

const EscrowFeesContext = createContext<EscrowFeesContextType>({ escrowFees: null })

export default EscrowFeesContext
